<template>
  <div>
    <div>
      <!-- <v-layout justify-center align-content-center>
      <v-subheader>Over the next few screens we will be asking questions about you and those you wish to seek coverage on (if applicable).</v-subheader>
      </v-layout>-->
      <!-- <v-card light class="infoCard"> -->
      <v-stepper v-model="e1">
        <v-stepper-header>
          <template v-for="(disp, index) in displayArray">
            <div :key="index">
              <v-stepper-step
                :complete="e1 > index + 1"
                :step="index + 1"
                @click="switchStep(index)"
              >
                <span v-if="$vuetify.breakpoint.mdAndUp">{{ disp.title }}</span>
              </v-stepper-step>
            </div>
            <v-divider :key="'divider' + index"></v-divider>
          </template>
          <v-stepper-step
            :complete="false"
            :step="maxIndex"
            @click="proceedClick(e1 - 1)"
          >
            <span v-if="$vuetify.breakpoint.mdAndUp"
              >Products and Questions</span
            >
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <template v-for="(disp, index) in displayArray">
            <v-stepper-content :step="index + 1" :key="index">
              <tmkDemographics
                :index="index"
                :personType="disp.type"
                :childIndex="disp.childIndex"
                :person="currentPerson(disp.type, disp.childIndex)"
                :mainColor="mainColor"
              ></tmkDemographics>

              <v-layout column v-if="$vuetify.breakpoint.smAndDown">
                <v-btn
                  :color="mainColor"
                  style="font-size: 0.85em"
                  dark
                  v-if="index + 1 > 1"
                  @click="backClick(index)"
                  >Back</v-btn
                >

                <v-btn
                  :color="mainColor"
                  dark
                  v-if="index === 0 && isAgentApplication"
                  @click="showVerification"
                  ><span>Back to LPB &amp; Employee ID</span></v-btn
                >

                <v-btn
                  :color="mainColor"
                  style="font-size: 0.85em"
                  dark
                  @click="nextClick(index)"
                >
                  <span v-if="showNext">Next</span>
                  <span v-else-if="index === 0">Add Spouse Or Child</span>
                  <span v-else>Add Child</span>
                </v-btn>

                <v-btn
                  :color="mainColor"
                  dark
                  @click="proceedClick(index)"
                  style="font-size: 0.85em"
                  >Proceed to Products and Questions</v-btn
                >
                <br />
              </v-layout>

              <v-layout align-end justify-end v-else>
                <v-btn
                  :color="mainColor"
                  dark
                  v-if="index + 1 > 1"
                  @click="backClick(index)"
                  >Back</v-btn
                >
                <v-btn
                  :color="mainColor"
                  dark
                  v-if="index === 0 && isAgentApplication"
                  @click="showVerification"
                  ><span>Back to LPB &amp; Employee ID</span></v-btn
                >
                <v-btn :color="mainColor" dark @click="nextClick(index)">
                  <span v-if="showNext">Next</span>
                  <span v-else-if="index === 0">Add Spouse Or Child</span>
                  <span v-else>Add Child</span>
                </v-btn>
                <v-btn :color="mainColor" dark @click="proceedClick(index)"
                  >Proceed to Products and Questions</v-btn
                >
              </v-layout>
            </v-stepper-content>
          </template>
        </v-stepper-items>
      </v-stepper>
      <!-- </v-card> -->
    </div>
  </div>
</template>

<script>
// import tmkDemographics from '../components/tmk-demographics.vue'
import eventBus from '../event-bus.js'
import store from '../store.js'

export default {
  name: 'ProposedInsureds',
  props: { mainColor: String, entity: Object },

  created() {
    if (store.state.individuals.length > 0) {
      this.showNext = true
    }

    if (store.state.individuals && store.state.individuals.length > 0) {
      for (let ci = 0; ci < store.state.individuals.length; ci++) {
        let childIndex = store.state.individuals[ci].childIndex

        if (childIndex >= 0) {
          this.displayArray.push({
            type: 'child',
            title: 'Child',
            ref: 'childDem',
            addBtn: true,
            removeBtn: true,
            opened: false,
            childIndex: childIndex,
          })
        }
      }
    }

    this.nextIdx = 2
    this.curChildIdx = -1
    this.step = ''
    this.maxIndex = this.displayArray.length + 1
  },
  watch: {
    e1() {
      this.maxIndex = this.displayArray.length + 1
      // this.$store.commit('setDemographicsPage', this.e1)
      // console.log(this.e1)
      // console.log(this.$store.state.demographicsPage)
    },
  },
  computed: {
    isAgentApplication() {
      if (
        this.$store.state.lpbAgent &&
        this.$store.state.lpbAgent.AgentNumber &&
        this.$store.state.lpbAgent.AgentNumber != ''
      )
        return true

      return false
    },

    displayArray: function () {
      let ret = [
        {
          type: 'employee',
          title: 'Employee',
          addBtn: false,
          childIndex: -1,
        },
        {
          type: 'spouse',
          title: 'Spouse',
          addBtn: true,
          childIndex: -1,
        },
      ]

      return ret
    },
  },
  mounted() {
    this.initialAppPersonsCount = this.$store.getters.applicableIndividuals

    // this.$nextTick(() => {
    //   console.log(this.$store.state.demographicsPage)
    //   this.e1 = this.$store.state.demographicsPage
    //   console.log(this.e1)
    // })

    eventBus.$on(
      'individualSaved',
      function () {
        if (this.step === 'backClick' || this.step === 'nextClick') {
          if (
            this.step === 'nextClick' &&
            this.e1 === this.displayArray.length
          ) {
            let maxChildIndex =
              this.displayArray[this.displayArray.length - 1].childIndex

            let newChild = {
              type: 'child',
              title: 'Child',
              addBtn: true,
              removeBtn: true,
              childIndex: maxChildIndex + 1,
            }

            this.displayArray.push(newChild)
          }

          if (this.step === 'nextClick') {
            eventBus.$emit('resetValidation', this.e1)

            if (this.nextIdx >= this.displayArray.length) {
              this.showNext = false
            }
          }
          this.e1 = this.nextIdx
          window.scrollTo(0, 0)
        } else if (this.step === 'proceedClick') {
          if (
            this.initialAppPersonsCount != store.getters.applicableIndividuals
          ) {
            this.$store.commit('setProductsPage', 2)
            this.$store.commit('setMaxTab', 2)
          }

          if (store.state.selections.length > 0) {
            // Adjust the selections if we've backtracked:

            let selections = store.state.selections

            store.commit('clearSelections')
            let appInds = store.getters.applicableIndividuals

            for (let person of appInds) {
              for (let idx = 0; idx < selections.length; idx++) {
                if (selections[idx].indexOf(person.id) >= 0) {
                  store.commit('addSelection', selections[idx])
                }
              }
            }
          }

          eventBus.$emit('showProducts')
        }
      }.bind(this)
    )

    eventBus.$on(
      'invalidEntries',
      function () {
        if (this.step === 'backClick') {
          this.e1 = this.nextIdx
        } else this.step = ''
      }.bind(this)
    )

    eventBus.$on(
      'showAddBtn',
      function (showthis) {
        this.showAddButton = showthis
      }.bind(this)
    )
  },
  beforeDestroy() {
    eventBus.$off('individualSaved')
    eventBus.$off('validateAndSaveInd')
    eventBus.$off('invalidEntries')
    eventBus.$off('resetValidation')
    eventBus.$off('showAddBtn')
  },

  data: () => ({
    e1: 1,
    valid: false,
    addBtn: true,
    nextIdx: 0,
    curChildIdx: 0,
    step: '',
    showAddButton: true,
    showNext: false,
    NA: false,
    maxIndex: 3,
    initialAppPersonsCount: 0,
  }),
  components: {
    tmkDemographics: () =>
      import(/* webpackPrefetch: true */ '../components/tmk-demographics.vue'),
  },
  methods: {
    showVerification() {
      this.$store.commit('clearLPB')
      eventBus.$emit('showVerification')
    },
    switchStep(index) {
      if (index === this.maxIndex) {
        this.proceedClick(this.e1)
      }

      if (this.e1 > index + 1) {
        this.nextIdx = index + 1
        this.step = 'backClick'
        this.showNext = true

        eventBus.$emit('validateAndSaveInd', this.e1 - 1, 'back')
      } else {
        if (this.e1 < index + 1) {
          this.nextIdx = index + 1
          this.step = 'nextClick'

          eventBus.$emit('validateAndSaveInd', this.e1 - 1, 'next')
        }
      }
    },
    backClick(index) {
      this.nextIdx = index < 1 ? this.displayArray.length : index
      this.step = 'backClick'
      this.showNext = true

      eventBus.$emit('validateAndSaveInd', index, 'back')
    },
    proceedClick(index) {
      this.nextIdx = 0
      this.step = 'proceedClick'

      eventBus.$emit('validateAndSaveInd', index, 'proceed')
    },
    nextClick(index) {
      this.nextIdx = index + 2
      this.step = 'nextClick'

      eventBus.$emit('validateAndSaveInd', index, 'next')
    },
    currentPerson(instype, childIndex) {
      return store.getters.getIndividualByTypeAndChildIndex(instype, childIndex)
    },
  },
}
</script>


<style scoped>
.padTop {
  margin-top: 20px;
}
.infoCard {
  margin-top: 25px;
  margin-bottom: 50px;
}
.v-stepper__header {
  overflow-y: hidden;
  overflow-x: auto;
  display: flex;
  flex-wrap: nowrap !important;
  justify-content: left;
}
.v-stepper__label {
  white-space: normal;
  display: inline-block !important;
}
</style>